<script>
export default {
  name: "EnIceCream",
  data() {
    return {
      iceCreams: [
        {
          name: "Chocolate",
          priceS: "cone 40 den.",
          priceL: "small cup 50 den.",
          priceXL: "big cup 70 den."
        },
        {
          name: "Vanilla",
          priceS: "cone 40 den.",
          priceL: "small cup 50 den.",
          priceXL: "big cup 70 den."
        },
        {
          name: "Strawberry",
          priceS: "cone 40 den.",
          priceL: "small cup 50 den.",
          priceXL: "big cup 70 den."
        },
        {
          name: "Mix",
          priceS: "cone 40 den.",
          priceL: "small cup 50 den.",
          priceXL: "big cup 70 den."
        },
      ],
    };
  },
}
</script>

<template>
<div class="main">
  <base-card v-for="iceCream in iceCreams" :key="iceCream.name">
    <v-card-title>{{ iceCream.name }}</v-card-title>
    <v-card-text>{{ iceCream.text }}</v-card-text>
    <v-card-actions class="flex text-right">
        <v-spacer></v-spacer>
        {{ iceCream.priceS }} <br />
        {{ iceCream.priceL }} <br />
        {{ iceCream.priceXL }}
    </v-card-actions>
  </base-card>
</div>
</template>

<style scoped>
.main {
  min-height: 100vh;
  background: transparent;
}
</style>